import {
  AsYouType,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
  validatePhoneNumberLength

} from 'libphonenumber-js';

jQuery(document).ready(function ($) {
    var dom = $('.qr-landing');
    var qrObject = {
        'dom': dom,
        'email': '',
        'phone': '',
        'uuid': '',
        'inputs': {
            'email': dom.find('.input--email'),
            'first': dom.find('.input--first-name'),
            'last': dom.find('.input--last-name'),
            'confirmation': dom.find('.input--confirmation'),
            'phone': dom.find('.input--phone'),
            'zip': dom.find('.input--zip'),
            'submit': dom.find('.qr-signup--submit'),
        },
        'gaconnector': {
            'all_traffic_sources': '',
            'fc_campaign': '',
            'fc_channel': '',
            'fc_content': '',
            'fc_landing': '',
            'fc_medium': '',
            'fc_referrer': '',
            'fc_source': '',
            'fc_term': '',
            'GA_Client_ID': '',
            'lc_campaign': '',
            'lc_channel': '',
            'lc_content': '',
            'lc_landing': '',
            'lc_medium': '',
            'lc_referrer': '',
            'lc_source': '',
            'lc_term': '',
            'page_visits': '',
            'time_passed': '',
            'device': '',
            'OS': '',
            'browser': '',
            'latitude': '',
            'longitude': ''
        },
        "values": {
            "Email": "",
            "Phone": "",
            "FirstName": "",
            "LastName": "",
            "PostalCode": "",
            "OPT-IN": "",
            "Country": "",
            "timezone": "",
            "PainfulDiabeticNeuropathy__c":"yes",
            "Affiliated_HCP__c":""
        },

        resetForm: function () {
            this.inputs.first.val('');
            this.inputs.last.val('');
            //this.inputs.confirmation.find(':checked').prop('checked', false);

            this.values.confirmation         = this.inputs.confirmation.prop('checked', false);
            this.checkPrivacy();
            this.dom.find('.has-error').removeClass('gfield_error');
        },
        setEmail: function () {
            this.inputs.email.val(this.email);
        },
        getTimezone: function (date) {
            return /\((.*)\)/.exec(date.toString())[1];
        },
        submitForm: function () {
            this.gatherData();
            this.gatherGAConnector();
            this.gatherCountryCode();

            if (this.validateForm()) {
                this.submitResults();

                // Submit GTM tag of start guide download popup
//              this.submitGTM('guide-download-form-complete','Guide Download Form Complete', window.location.href );
            } else {
                console.log('Form not valid!');
            }
        },
        gatherData: function () {
            this.values.Email                = this.inputs.email.val().trim();
            this.values.Phone                = this.inputs.phone.val().trim();
            this.values['First Name']        = this.inputs.first.val();
            this.values['Last Name']         = this.inputs.last.val();
            this.values.PostalCode           = this.inputs.zip.val();
            this.values.Affiliated_HCP__c    = this.dom.find("input[name='Affiliated_HCP__c']").val().trim();
//          this.values.confirmation         = this.inputs.confirmation.find(':checked').val();
            this.values.confirmation         = this.inputs.confirmation.prop('checked');
            this.values.timezone             = this.getTimezone(new Date());
        },
        gatherCountryCode: function() {
            //This is a bit of a hack as it assumes this input is some place on that page
            this.values.Country =  $("input[name='patient_assessment_country']").val();
        },
        returnCountryCode: function() {
            this.gatherCountryCode();
            return this.values.Country;
        },
        gatherGAConnector: function() {
            // this.gaconnector.all_traffic_sources = document.getElementsByName("all_traffic_sources")[0].value;
            this.gaconnector.all_traffic_sources = this.dom.find("input[name='all_traffic_sources']").val();
            this.gaconnector.fc_campaign = this.dom.find("input[name='fc_campaign']").val();
            this.gaconnector.fc_channel = this.dom.find("input[name='fc_channel']").val();
            this.gaconnector.fc_content = this.dom.find("input[name='fc_content']").val();
            this.gaconnector.fc_landing = this.dom.find("input[name='fc_landing']").val();
            this.gaconnector.fc_medium = this.dom.find("input[name='fc_medium']").val();
            this.gaconnector.fc_referrer = this.dom.find("input[name='fc_referrer']").val();
            this.gaconnector.fc_source = this.dom.find("input[name='fc_source']").val();
            this.gaconnector.fc_term = this.dom.find("input[name='fc_term']").val();
            this.gaconnector.GA_Client_ID = this.dom.find("input[name='GA_Client_ID']").val();
            this.gaconnector.lc_campaign = this.dom.find("input[name='lc_campaign']").val();
            this.gaconnector.lc_channel  = this.dom.find("input[name='lc_channel']").val();
            this.gaconnector.lc_content = this.dom.find("input[name='lc_content']").val();
            this.gaconnector.lc_landing = this.dom.find("input[name='lc_landing']").val();
            this.gaconnector.lc_medium = this.dom.find("input[name='lc_medium']").val();
            this.gaconnector.lc_referrer = this.dom.find("input[name='lc_referrer']").val();
            this.gaconnector.lc_source = this.dom.find("input[name='lc_source']").val();
            this.gaconnector.lc_term = this.dom.find("input[name='lc_term']").val();
            this.gaconnector.page_visits = this.dom.find("input[name='page_visits']").val();
            this.gaconnector.time_passed = this.dom.find("input[name='time_passed']").val();
            this.gaconnector.OS = this.dom.find("input[name='OS']").val();
            this.gaconnector.browser = this.dom.find("input[name='browser']").val();
            this.gaconnector.latitude = this.dom.find("input[name='latitude']").val();
            this.gaconnector.longitude = this.dom.find("input[name='longitude']").val();
            this.gaconnector.device = this.dom.find("input[name='device']").val();
        },
        validateForm: function () {
            var isValid = true;
            if(!this.validateNameFields()){
               isValid = false;
            }
            if (!this.validateEmail()) {
                isValid = false;
            }
            if (!this.validatePhone()) {
                isValid = false;
            }
            if (!this.validateZipCode()) {
                isValid = false;
            }
            if (!this.validatePrivacyField()) {
                isValid = false;
            }
            return isValid;
        },
        checkPrivacy: function () {
            qrObject.gatherData();
            if (this.validatePrivacyField()) {
                this.inputs.submit.prop('disabled', false);
            }
            else {
                this.inputs.submit.prop('disabled', true);
            }
        },
        submitResults: function () {
//          qrObject.dom.find('#qr-signup--submit').prop('disabled', true).addClass('o-ajax-progress');
            var values = {
                "Email": this.values.Email,
                "Phone": this.values.Phone,
                "FirstName": this.values["First Name"],
                "LastName": this.values["Last Name"],
                "PostalCode": this.values.PostalCode,
                "Country": this.values.Country,
                "OPT-IN": this.values["OPT-IN"],
                "Affiliated_HCP__c":this.values.Affiliated_HCP__c,
                "Privacy": this.values.confirmation,
                "PainfulDiabeticNeuropathy__c":"yes",
                "Patient_Time_zone__c": this.values.timezone,
                "All_Traffic_Sources__c": this.gaconnector.all_traffic_sources,
                "gaconnector_First_Click_Campaign__c": this.gaconnector.fc_campaign,
                "gaconnector_First_Click_Channel__c": this.gaconnector.fc_channel,
                "gaconnector_First_Click_Content__c": this.gaconnector.fc_content,
                "gaconnector_First_Click_Landing_Page__c": this.gaconnector.fc_landing,
                "gaconnector_First_Click_Medium__c": this.gaconnector.fc_medium,
                "gaconnector_First_Click_Referrer__c": this.gaconnector.fc_referrer,
                "gaconnector_First_Click_Source__c": this.gaconnector.fc_source,
                "gaconnector_First_Click_Term__c": this.gaconnector.fc_term,
                "gaconnector_Google_Analytics_Client_ID__c": this.gaconnector.GA_Client_ID,
                "gaconnector_Last_Click_Campaign__c": this.gaconnector.lc_campaign,
                "gaconnector_Last_Click_Channel__c": this.gaconnector.lc_channel,
                "gaconnector_Last_Click_Content__c": this.gaconnector.lc_content,
                "gaconnector_Last_Click_Landing_Page__c": this.gaconnector.lc_landing,
                "gaconnector_Last_Click_Medium__c": this.gaconnector.lc_medium,
                "gaconnector_Last_Click_Referrer__c": this.gaconnector.lc_referrer,
                "gaconnector_Last_Click_Source__c": this.gaconnector.lc_source,
                "gaconnector_Last_Click_Term__c": this.gaconnector.lc_term,
                "gaconnector_Number_of_Website_Visits__c": this.gaconnector.page_visits,
                "gaconnector_Time_Spent_on_Website__c": this.gaconnector.time_passed,
                "gaconnector_Operating_System__c": this.gaconnector.OS,
                "gaconnector_Browser__c": this.gaconnector.browser,
                "gaconnector_Latitude_from_IP__c": this.gaconnector.latitude,
                "gaconnector_Longitude__c": this.gaconnector.longitude,
                "Device__c": this.gaconnector.device
            };

            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'more-info-qr'
                },
                success: function (rawhtml) {
                    qrObject.dom.addClass('form-complete');

                }
            });

            window.scroll(0,0);

            jQuery('.qr-landing__form').css({'display':'none'});
            jQuery('.qr-landing__form-thankyou').css({'display':'block'});

        },
        // validation ___________________///
        validateNameFields: function () {
            var result = true;
            if (this.values['First Name'].length < 1) {
                result = false;
                this.inputs.first.parents('.gfield').addClass('gfield_error');
            } else {
                this.inputs.first.parents('.gfield').removeClass('gfield_error');
            }

            if (this.values['Last Name'].length < 1) {
                result = false;
                this.inputs.last.parents('.gfield').addClass('gfield_error');
            } else {
                this.inputs.last.parents('.gfield').removeClass('gfield_error');
            }
            return result;
        },

        gatherGAConnector: function() {
            // this.gaconnector.all_traffic_sources = document.getElementsByName("all_traffic_sources")[0].value;
            this.gaconnector.all_traffic_sources = this.dom.find("input[name='all_traffic_sources']").val();
            this.gaconnector.fc_campaign = this.dom.find("input[name='fc_campaign']").val();
            this.gaconnector.fc_channel = this.dom.find("input[name='fc_channel']").val();
            this.gaconnector.fc_content = this.dom.find("input[name='fc_content']").val();
            this.gaconnector.fc_landing = this.dom.find("input[name='fc_landing']").val();
            this.gaconnector.fc_medium = this.dom.find("input[name='fc_medium']").val();
            this.gaconnector.fc_referrer = this.dom.find("input[name='fc_referrer']").val();
            this.gaconnector.fc_source = this.dom.find("input[name='fc_source']").val();
            this.gaconnector.fc_term = this.dom.find("input[name='fc_term']").val();
            this.gaconnector.GA_Client_ID = this.dom.find("input[name='GA_Client_ID']").val();
            this.gaconnector.lc_campaign = this.dom.find("input[name='lc_campaign']").val();
            this.gaconnector.lc_channel  = this.dom.find("input[name='lc_channel']").val();
            this.gaconnector.lc_content = this.dom.find("input[name='lc_content']").val();
            this.gaconnector.lc_landing = this.dom.find("input[name='lc_landing']").val();
            this.gaconnector.lc_medium = this.dom.find("input[name='lc_medium']").val();
            this.gaconnector.lc_referrer = this.dom.find("input[name='lc_referrer']").val();
            this.gaconnector.lc_source = this.dom.find("input[name='lc_source']").val();
            this.gaconnector.lc_term = this.dom.find("input[name='lc_term']").val();
            this.gaconnector.page_visits = this.dom.find("input[name='page_visits']").val();
            this.gaconnector.time_passed = this.dom.find("input[name='time_passed']").val();
            this.gaconnector.OS = this.dom.find("input[name='OS']").val();
            this.gaconnector.browser = this.dom.find("input[name='browser']").val();
            this.gaconnector.latitude = this.dom.find("input[name='latitude']").val();
            this.gaconnector.longitude = this.dom.find("input[name='longitude']").val();
            this.gaconnector.device = this.dom.find("input[name='device']").val();
        },
        validateZipCode: function () {
            var result = true;
            var error_code = this.testZipCode(this.values.PostalCode);
            var error_message = "";

            if (this.values.PostalCode.length < 1) {
                result = false;
                error_message = 'Zip Code required';
                this.inputs.zip.parents('.gfield').addClass('gfield_error');
            } else {
                this.inputs.zip.parents('.gfield').removeClass('gfield_error');
            }

            if (error_code === 2) {
                result = false;
                this.inputs.zip.parents('.gfield').addClass('gfield_error');
            } else {
                this.inputs.zip.parents('.gfield').removeClass('gfield_error');
            }
            return result;
        },
        testZipCode: function (zipcode) {
            this.gatherCountryCode();//required to make sure this.values.Country is populated
            let patientAssessmentValidationCountryCode = this.values.Country;
            let error_code = '';
            if(patientAssessmentValidationCountryCode == "Australia"){
   //           var re = /^[0-9]{4}/;
                var re = /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
//             }else if(patientAssessmentValidationCountryCode == "Germany"){
//                 var re = /\d{5}-\d{4}$|^\d{5}$/;
//                 if (!re.test(zipcode)) {
//                     error_code = 2;
//                     return error_code;
//                 }
//             }else if(patientAssessmentValidationCountryCode == "United States"){
            } else {
                var re = /\d{5}-\d{4}$|^\d{5}$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
            }
            return error_code;
        },
        formatPhoneNumber: function(inputPhoneNumber){
            //this should be hard coded in the form at this point
            let countryCode = this.returnCountryCode();
            if(countryCode == "United States"){
                let phoneNumber = new AsYouType('US').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'US') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'US');
                    phoneNumber = phoneNumberParser.format("NATIONAL");
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Germany"){
                let phoneNumber = new AsYouType('DE').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'DE') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'DE');
                    phoneNumber = phoneNumberParser.format("NATIONAL");
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Australia"){
                let phoneNumber = new AsYouType('AU').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'AU') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'AU');
                    phoneNumber = phoneNumberParser.format("NATIONAL");
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else {
                return false;
            }
        },
        validateEmail: function () {
            var result = true;
            var error_code = this.testEmail(this.values.Email);
            var error_message = "";

            switch(error_code) {
                case 0:
                    error_message = 'Email address required';
                    break;
                case -1:
                    error_message = 'An @ sign is required';
                    break;
                case 1:
                    error_message = 'Please remove whitespace';
                    break;
                default:
                    error_message = 'Please enter a valid email address';
            }

            if (error_code <= 1) {
                result = false;
                this.inputs.email.parents('.gfield').addClass('gfield_error');
                this.dom.find("label[for='ns_input_2_3'] > span").text(error_message);
            }else{
                this.inputs.email.parents('.gfield').removeClass('gfield_error');
            }
            return result;
        },


        validatePhone : function(){
            var result = true;
            this.gatherCountryCode();//required to make sure this.values.Country is populated
            let patientAssessmentValidationCountryCode = this.values.Country;
            let validatePhoneValue = this.values.Phone;
//          if(validatePhoneValue.length > 0) {
                if(patientAssessmentValidationCountryCode == "United States"){
                    if(  !isValidPhoneNumber(validatePhoneValue, 'US') ){
                        result = false;
                        this.inputs.phone.parents('.gfield').addClass('gfield_error');
                    }else{
                        this.inputs.phone.parents('.gfield').removeClass('gfield_error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Australia"){
                    if( (validatePhoneValue.length > 0)  && !isValidPhoneNumber(validatePhoneValue, 'AU') ){
                        result = false;
                        this.inputs.phone.parents('.gfield').addClass('gfield_error');
                    }else{
                        this.inputs.phone.parents('.gfield').removeClass('gfield_error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Germany"){
                    if( (validatePhoneValue.length > 0)  && !isValidPhoneNumber(validatePhoneValue, 'DE') ){
                        result = false;
                        this.inputs.phone.parents('.gfield').addClass('gfield_error');
                    }else{
                        this.inputs.phone.parents('.gfield').removeClass('gfield_error');
                    }
                }else{
                    if(validatePhoneValue.length > 0 && validatePhoneValue.length > 20 ){
                        result = false;
                        this.inputs.phone.parents('.gfield').addClass('gfield_error');
                    }else{
                        this.inputs.phone.parents('.gfield').removeClass('gfield_error');
                    }
                }
//           }
            return result;
        },


        validatePrivacyField: function () {
            var result = true;
            //if (this.values.confirmation !== "true") {
            if (!this.values.confirmation) {
                result = false;
                this.inputs.confirmation.parents('.gfield').addClass('gfield_error');
            } else {
                this.inputs.confirmation.parents('.gfield').removeClass('gfield_error');
            }
            return result;
        },

        testEmail: function (email) {
            var error_code = '';

            if (email.length === 0) {
                error_code = 0;
                return error_code;
            }

            if (email.indexOf('@') === -1) {
                error_code = email.indexOf('@');
                return error_code;
            }

            if (email.indexOf(' ') !== -1) {
              error_code = 1;
              return error_code;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(email)) {
                error_code = -2;
                return error_code;
            }
        },

        submitGTM: function (pageSlug, pageName, locationURL) {
            if (qrObject.uuid.length < 1) {
                qrObject.uuid = window.getCookie('visitorUUID');
            }
            dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': '/qr/' + pageSlug,
                'virtualPageTitle': pageName,
                'answer': locationURL,
                'UUID': qrObject.uuid
            });
        }
    };

    qrObject.inputs.confirmation.on('click', function () {
        qrObject.checkPrivacy();
    });

    qrObject.dom.on('click', '#qr-signup--submit', function (e) {
        e.preventDefault();
        qrObject.submitForm();
    });

    qrObject.dom.on('keyup', '#phone_number', function (e) {
//      var _this = $("#phone_number");
//      //var phone_number = new libphonenumber.AsYouType('US').input(_this.val());

//      var phone_number = new AsYouType('US').input(_this.val());
//      var dashPlacement = phone_number.indexOf('-');
//      if (dashPlacement > 0 && phone_number.length >= dashPlacement + 6) {
//          phone_number = phone_number.substring(0, dashPlacement + 6);
//      } else if (dashPlacement < 0) {
//          if (phone_number.charAt(0) === "1" && (phone_number.length > 10 && phone_number.indexOf('(') < 0)) {
//              phone_number = phone_number.substring(0, 11);
//              phone_number = new libphonenumber.AsYouType('US').input(phone_number);
//          } else if (phone_number.charAt(0) !== "1" && (phone_number.length > 10 && phone_number.indexOf('(') < 0)) {
//              phone_number = phone_number.substring(0, 10);
//              phone_number = new libphonenumber.AsYouType('US').input(phone_number);
//          }
//      }
//      _this.val(phone_number);


        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = qrObject.formatPhoneNumber( $("#phone_number").val());
            $("#phone_number").val(delayFormat);
        },  1000);


    });

});
